import './SearchListControl.svelte.css';
/* src/components/searchList/SearchListControl.svelte generated by Svelte v3.46.4 */
import {
	SvelteComponent,
	add_render_callback,
	append,
	attr,
	create_bidirectional_transition,
	detach,
	element,
	init,
	insert,
	is_function,
	listen,
	run_all,
	safe_not_equal,
	space,
	text
} from "../../../_snowpack/pkg/svelte/internal.js";

import { fade } from '../../../_snowpack/pkg/svelte/transition.js';

function create_fragment(ctx) {
	let li;
	let button0;
	let t0;
	let t1;
	let button1;
	let t2;
	let li_transition;
	let current;
	let mounted;
	let dispose;

	return {
		c() {
			li = element("li");
			button0 = element("button");
			t0 = text("前へ");
			t1 = space();
			button1 = element("button");
			t2 = text("次へ");
			attr(button0, "class", "prev svelte-32c26c");
			button0.value = "prev";
			button0.disabled = /*disabledprev*/ ctx[0];
			attr(button1, "class", "next svelte-32c26c");
			button1.value = "next";
			button1.disabled = /*disablednext*/ ctx[1];
			attr(li, "class", "search-excerpt-pagectl svelte-32c26c");
		},
		m(target, anchor) {
			insert(target, li, anchor);
			append(li, button0);
			append(button0, t0);
			append(li, t1);
			append(li, button1);
			append(button1, t2);
			current = true;

			if (!mounted) {
				dispose = [
					listen(button0, "click", function () {
						if (is_function(/*turn*/ ctx[2])) /*turn*/ ctx[2].apply(this, arguments);
					}),
					listen(button1, "click", function () {
						if (is_function(/*turn*/ ctx[2])) /*turn*/ ctx[2].apply(this, arguments);
					})
				];

				mounted = true;
			}
		},
		p(new_ctx, [dirty]) {
			ctx = new_ctx;

			if (!current || dirty & /*disabledprev*/ 1) {
				button0.disabled = /*disabledprev*/ ctx[0];
			}

			if (!current || dirty & /*disablednext*/ 2) {
				button1.disabled = /*disablednext*/ ctx[1];
			}
		},
		i(local) {
			if (current) return;

			add_render_callback(() => {
				if (!li_transition) li_transition = create_bidirectional_transition(li, fade, { delay: 250, duration: 300 }, true);
				li_transition.run(1);
			});

			current = true;
		},
		o(local) {
			if (!li_transition) li_transition = create_bidirectional_transition(li, fade, { delay: 250, duration: 300 }, false);
			li_transition.run(0);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(li);
			if (detaching && li_transition) li_transition.end();
			mounted = false;
			run_all(dispose);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let { disabledprev } = $$props;
	let { disablednext } = $$props;
	let { turn } = $$props;

	$$self.$$set = $$props => {
		if ('disabledprev' in $$props) $$invalidate(0, disabledprev = $$props.disabledprev);
		if ('disablednext' in $$props) $$invalidate(1, disablednext = $$props.disablednext);
		if ('turn' in $$props) $$invalidate(2, turn = $$props.turn);
	};

	return [disabledprev, disablednext, turn];
}

class SearchListControl extends SvelteComponent {
	constructor(options) {
		super();

		init(this, options, instance, create_fragment, safe_not_equal, {
			disabledprev: 0,
			disablednext: 1,
			turn: 2
		});
	}
}

export default SearchListControl;